import { render } from "./closer.vue?vue&type=template&id=5cde555f"
import script from "./closer.vue?vue&type=script&lang=js"
export * from "./closer.vue?vue&type=script&lang=js"

import "./closer.vue?vue&type=style&index=0&id=5cde555f&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__